import React from 'react';
import PropTypes from 'prop-types';

const TabIcon = ({ className, width, height, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 56.076 70"
  >
    <g transform="translate(-115.1 -24.2)">
      <path
        fill={fill}
        d="M151.433,94.2a3.975,3.975,0,0,1-2.447-.845L143.131,88.8l-5.848,4.552a3.982,3.982,0,0,1-4.93-.022l-5.775-4.581-7.064,4.872a2.769,2.769,0,0,1-2.869.175,2.908,2.908,0,0,1-1.544-2.593V27.113a2.873,2.873,0,0,1,2.833-2.913h50.41a2.877,2.877,0,0,1,2.833,2.913V91.2a2.9,2.9,0,0,1-1.544,2.593,2.769,2.769,0,0,1-2.869-.175l-7.057-4.872-5.8,4.588A3.913,3.913,0,0,1,151.433,94.2Zm17.82-4.173Zm-26.123-6.765,8.3,6.467,8.105-6.409,7.275,5.025V28.57H119.477V88.345l7.29-5.025,8.069,6.409Z"
      />
      <path
        fill={fill}
        d="M482.8,190.67H464.785a2.185,2.185,0,0,1,0-4.37H482.8a2.185,2.185,0,0,1,0,4.37Z"
        transform="translate(-322.193 -150.295)"
      />
      <path
        fill={fill}
        d="M477.223,319.77H464.785a2.185,2.185,0,1,1,0-4.37h12.439a2.185,2.185,0,1,1,0,4.37Z"
        transform="translate(-322.193 -269.993)"
      />
      <path
        fill={fill}
        d="M482.8,555.27H464.785a2.185,2.185,0,0,1,0-4.37H482.8a2.185,2.185,0,0,1,0,4.37Z"
        transform="translate(-322.193 -488.343)"
      />
      <path
        fill={fill}
        d="M476.361,684.37H462.685a2.185,2.185,0,1,1,0-4.37h13.684a2.185,2.185,0,1,1-.007,4.37Z"
        transform="translate(-320.246 -608.041)"
      />
      <g transform="translate(124.211 35.874)">
        <path
          fill={fill}
          d="M247.869,184.5v13.611h-3.758V189.2a10.9,10.9,0,0,1-1.77,1.122,13.962,13.962,0,0,1-2.141.823V188.09a8.966,8.966,0,0,0,2.949-1.471A6.059,6.059,0,0,0,244.8,184.5Z"
          transform="translate(-240.2 -184.5)"
        />
      </g>
      <g transform="translate(123.191 62.142)">
        <path
          fill={fill}
          d="M237.357,558.818H226.2a7.032,7.032,0,0,1,1.165-3.11,15.664,15.664,0,0,1,3.649-3.437,10.942,10.942,0,0,0,2.09-1.842,2.058,2.058,0,0,0,.459-1.194,1.416,1.416,0,0,0-.452-1.049,1.56,1.56,0,0,0-1.136-.437,1.593,1.593,0,0,0-1.165.444,2.745,2.745,0,0,0-.6,1.58l-3.729-.291a6,6,0,0,1,.8-2.454,3.754,3.754,0,0,1,1.646-1.355,7.439,7.439,0,0,1,2.942-.473,8.285,8.285,0,0,1,3.051.444,3.744,3.744,0,0,1,1.719,1.376,3.647,3.647,0,0,1,.626,2.076,4.288,4.288,0,0,1-.714,2.338,9.865,9.865,0,0,1-2.607,2.447c-.75.517-1.253.881-1.5,1.085s-.546.481-.888.816h5.8Z"
          transform="translate(-226.2 -545.2)"
        />
      </g>
    </g>
  </svg>
  // <svg xmlns="http://www.w3.org/2000/svg" width="56.076" height="70" viewBox="0 0 56.076 70"><defs><style>.a{fill:#374542;}</style></defs><g transform="translate(-115.1 -24.2)"><path class="a" d="M151.433,94.2a3.975,3.975,0,0,1-2.447-.845L143.131,88.8l-5.848,4.552a3.982,3.982,0,0,1-4.93-.022l-5.775-4.581-7.064,4.872a2.769,2.769,0,0,1-2.869.175,2.908,2.908,0,0,1-1.544-2.593V27.113a2.873,2.873,0,0,1,2.833-2.913h50.41a2.877,2.877,0,0,1,2.833,2.913V91.2a2.9,2.9,0,0,1-1.544,2.593,2.769,2.769,0,0,1-2.869-.175l-7.057-4.872-5.8,4.588A3.913,3.913,0,0,1,151.433,94.2Zm17.82-4.173Zm-26.123-6.765,8.3,6.467,8.105-6.409,7.275,5.025V28.57H119.477V88.345l7.29-5.025,8.069,6.409Z"/><path class="a" d="M482.8,190.67H464.785a2.185,2.185,0,0,1,0-4.37H482.8a2.185,2.185,0,0,1,0,4.37Z" transform="translate(-322.193 -150.295)"/><path class="a" d="M477.223,319.77H464.785a2.185,2.185,0,1,1,0-4.37h12.439a2.185,2.185,0,1,1,0,4.37Z" transform="translate(-322.193 -269.993)"/><path class="a" d="M482.8,555.27H464.785a2.185,2.185,0,0,1,0-4.37H482.8a2.185,2.185,0,0,1,0,4.37Z" transform="translate(-322.193 -488.343)"/><path class="a" d="M476.361,684.37H462.685a2.185,2.185,0,1,1,0-4.37h13.684a2.185,2.185,0,1,1-.007,4.37Z" transform="translate(-320.246 -608.041)"/><g transform="translate(124.211 35.874)"><path class="a" d="M247.869,184.5v13.611h-3.758V189.2a10.9,10.9,0,0,1-1.77,1.122,13.962,13.962,0,0,1-2.141.823V188.09a8.966,8.966,0,0,0,2.949-1.471A6.059,6.059,0,0,0,244.8,184.5Z" transform="translate(-240.2 -184.5)"/></g><g transform="translate(123.191 62.142)"><path class="a" d="M237.357,558.818H226.2a7.032,7.032,0,0,1,1.165-3.11,15.664,15.664,0,0,1,3.649-3.437,10.942,10.942,0,0,0,2.09-1.842,2.058,2.058,0,0,0,.459-1.194,1.416,1.416,0,0,0-.452-1.049,1.56,1.56,0,0,0-1.136-.437,1.593,1.593,0,0,0-1.165.444,2.745,2.745,0,0,0-.6,1.58l-3.729-.291a6,6,0,0,1,.8-2.454,3.754,3.754,0,0,1,1.646-1.355,7.439,7.439,0,0,1,2.942-.473,8.285,8.285,0,0,1,3.051.444,3.744,3.744,0,0,1,1.719,1.376,3.647,3.647,0,0,1,.626,2.076,4.288,4.288,0,0,1-.714,2.338,9.865,9.865,0,0,1-2.607,2.447c-.75.517-1.253.881-1.5,1.085s-.546.481-.888.816h5.8Z" transform="translate(-226.2 -545.2)"/></g></g></svg>
);

TabIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};

TabIcon.defaultProps = {
  height: '100%',
  fill: 'currentColor',
};

export default TabIcon;
